// @flow
import React from 'react';
import CustomTable from 'components/fragments/CustomTable';

import type { CompetitionStatsType } from 'types/competitionsInternationales';

type Props = {
  competition_stats: CompetitionStatsType
};

function CompetitionsInternationalesHomeOverGroupTab({ competition_stats }: Props) {
  const tableData = [
    [
      `<strong>Victoires</strong><br/>${competition_stats.victoires}`,
      `<strong>Transformations</strong><br/>${competition_stats.transformations}`,
      `<strong>Essais marqués</strong><br/>${competition_stats.essais_marques}`
    ],
    [
      `<strong>Défaites</strong><br/>${competition_stats.defaites}`,
      `<strong>Pénalités</strong><br/>${competition_stats.penalites}`,
      `<strong>Essais encaissés</strong><br/>${competition_stats.essais_ensaisses}`
    ]
  ];

  return <CustomTable tableData={tableData} />;
}

export default CompetitionsInternationalesHomeOverGroupTab;
